module.exports = __webpack_public_path__ + "img/product4.c7d81b64.jpg";